<div class="row">
  <div *ngFor="let infoDate of headerWidgetsData$.value; let i = index" id="finance-infoData-{{i}}" class="col-12 col-md-6 col-lg-3">
    <widget-info id="finance-widget-info-{{i}}" [text]="infoDate.text" [title]="infoDate.title" [textSub]="infoDate.overLine" [icon]="infoDate.icon"
      [color]="infoDate.color">
    </widget-info>
  </div>
</div>
<div class="row mt-24">
  <div data-testid="gross-fare-by-travel-type-widget-container" class="col-md-6 mt-24">
    <widget data-testid="gross-fare-subRet-widget" title="Gross Fare By Travel Type" [subTitle]="'Distribution of gross fare by travel type in ' + (financeGrossTravelTypeChartType === FinanceChartPresentationTypeEnum.Amount ? 'amount' : 'percentage') + ' ' + selectedDataSource()">
      <ng-container data-testid="gross-fare-by-travel-type-actions" widgetActions>
          <button data-testid="gross-fare-by-travel-type-amount-button" mat-menu-item (click)="financeGrossTravelTypeChartType = FinanceChartPresentationTypeEnum.Amount">
            <mat-icon>attach_money</mat-icon>
            <span>Amount</span>
          </button>
          <button data-testid="gross-fare-by-travel-type-percentage-button" mat-menu-item (click)="financeGrossTravelTypeChartType = FinanceChartPresentationTypeEnum.Percentage">
            <mat-icon>percent</mat-icon>
            <span>Percentage</span>
          </button>
        </ng-container>
      <div data-testid="gross-fare-by-travel-type-chart-wrap" class="widget-chart-wrap" widgetContent>
        <app-gross-fare-by-travel-type [data]="grossFareByTravelTypeChartData" [presentationType]="financeGrossTravelTypeChartType"/>
      </div>
    </widget>
  </div>
  <div data-testid="commission-by-travel-type-widget-container" class="col-md-6 mt-24">
    <widget data-testid="commission-by-travel-type-widget" title="Commission By Travel Type" [subTitle]="'Distribution of commission by travel type in ' + (financeCommTravelTypeChartType === FinanceChartPresentationTypeEnum.Amount ? 'amount' : 'percentage') + ' ' + selectedDataSource()">
      <ng-container data-testid="commission-by-travel-type-actions" widgetActions>
        <button data-testid="commission-by-travel-type-amount-button" mat-menu-item (click)="financeCommTravelTypeChartType = FinanceChartPresentationTypeEnum.Amount">
          <mat-icon>attach_money</mat-icon>
          <span>Amount</span>
        </button>
        <button data-testid="commission-by-travel-type-percentage-button" mat-menu-item (click)="financeCommTravelTypeChartType = FinanceChartPresentationTypeEnum.Percentage">
          <mat-icon>percent</mat-icon>
          <span>Percentage</span>
        </button>
      </ng-container>
      <div data-testid="commission-by-travel-type-chart-wrap" class="widget-chart-wrap" widgetContent>
        <app-commission-by-travel-type [data]="commissionByTravelTypeChartData" [presentationType]="financeCommTravelTypeChartType"/>
      </div>
    </widget>
  </div>
  <div data-testid="gross-fare-by-external-travel-type-widget-container" class="col-md-6 mt-24">
    <widget data-testid="gross-fare-by-external-travel-type-widget" title="Gross Fare By External Travel Type" [subTitle]="'Distribution of gross fare by external travel type in ' + (financeGrossExternalTravelTypeChartType === FinanceChartPresentationTypeEnum.Amount ? 'amount' : 'percentage') + ' ' + selectedDataSource()">
      <ng-container data-testid="gross-fare-by-external-travel-type-actions" widgetActions>
          <button data-testid="gross-fare-by-external-travel-type-amount-button" mat-menu-item (click)="financeGrossExternalTravelTypeChartType = FinanceChartPresentationTypeEnum.Amount">
            <mat-icon>attach_money</mat-icon>
            <span>Amount</span>
          </button>
          <button data-testid="gross-fare-by-external-travel-type-percentage-button" mat-menu-item (click)="financeGrossExternalTravelTypeChartType = FinanceChartPresentationTypeEnum.Percentage">
            <mat-icon>percent</mat-icon>
            <span>Percentage</span>
          </button>
        </ng-container>
      <div data-testid="gross-fare-by-external-travel-type-chart-wrap" class="widget-chart-wrap" widgetContent>
        <app-gross-fare-by-external-travel-type [data]="grossFareByExternalTravelTypeChartData" [presentationType]="financeGrossExternalTravelTypeChartType"/>
      </div>
    </widget>
  </div>
  <div data-testid="commission-by-external-travel-type-widget-container" class="col-md-6 mt-24">
    <widget data-testid="commission-by-external-travel-type-widget" title="Commission By External Travel Type" [subTitle]="'Distribution of commission by external travel type in ' + (financeCommExternalTravelTypeChartType === FinanceChartPresentationTypeEnum.Amount ? 'amount' : 'percentage') + ' ' + selectedDataSource()">
      <ng-container data-testid="commission-by-external-travel-type-actions" widgetActions>
        <button data-testid="commission-by-external-travel-type-amount-button" mat-menu-item (click)="financeCommExternalTravelTypeChartType = FinanceChartPresentationTypeEnum.Amount">
          <mat-icon>attach_money</mat-icon>
          <span>Amount</span>
        </button>
        <button data-testid="commission-by-external-travel-type-percentage-button" mat-menu-item (click)="financeCommExternalTravelTypeChartType = FinanceChartPresentationTypeEnum.Percentage">
          <mat-icon>percent</mat-icon>
          <span>Percentage</span>
        </button>
      </ng-container>
      <div data-testid="commission-by-external-travel-type-chart-wrap" class="widget-chart-wrap" widgetContent>
        <app-commission-by-external-travel-type [data]="commissionByExternalTravelTypeChartData" [presentationType]="financeCommExternalTravelTypeChartType"/>
      </div>
    </widget>
  </div>
  <div data-testid="gross-fare-by-submit-to-widget-container" class="col-md-6 mt-24">
    <widget data-testid="gross-fare-by-submit-to-widget"  title="Gross Fare By Submit To" [subTitle]="'Distribution of gross fare by submit to type in ' + (grossFareSubmitToChartType === FinanceChartPresentationTypeEnum.Amount ? 'amount' : 'percentage') + ' ' + selectedDataSource()">
      <ng-container data-testid="gross-fare-by-submit-to-actions" widgetActions>
        <button data-testid="gross-fare-by-submit-to-amount-button" mat-menu-item (click)="grossFareSubmitToChartType = FinanceChartPresentationTypeEnum.Amount">
          <mat-icon>attach_money</mat-icon>
          <span>Amount</span>
        </button>
        <button data-testid="gross-fare-by-submit-to-percentage-button" mat-menu-item (click)="grossFareSubmitToChartType = FinanceChartPresentationTypeEnum.Percentage">
          <mat-icon>percent</mat-icon>
          <span>Percentage</span>
        </button>
      </ng-container>
      <div data-testid="gross-fare-by-submit-to-chart-wrap" class="widget-chart-wrap" widgetContent>
        <app-gross-fare-by-submit-to [data]="grossFareBySubmitToChartData" [presentationType]="grossFareSubmitToChartType"/>
      </div>
    </widget>
  </div>
  <div data-testid="commission-by-submit-to-widget-container" class="col-md-6 mt-24">
    <widget data-testid="commission-by-submit-to-widget" title="Commission By Submit To" [subTitle]="'Distribution of commission by submit to type in ' + (commissionSubmitToChartType === FinanceChartPresentationTypeEnum.Amount ? 'amount' : 'percentage') + ' ' + selectedDataSource()">
      <ng-container data-testid="commission-by-submit-to-actions" widgetActions>
        <button data-testid="commission-by-submit-to-amount-button" mat-menu-item (click)="commissionSubmitToChartType = FinanceChartPresentationTypeEnum.Amount">
          <mat-icon>attach_money</mat-icon>
          <span>Amount</span>
        </button>
        <button data-testid="commission-by-submit-to-percentage-button" mat-menu-item (click)="commissionSubmitToChartType = FinanceChartPresentationTypeEnum.Percentage">
          <mat-icon>percent</mat-icon>
          <span>Percentage</span>
        </button>
      </ng-container>
      <div data-testid="commission-by-submit-to-chart-wrap" class="widget-chart-wrap" widgetContent>
        <app-commission-by-submit-to [data]="commissionBySubmitToChartData" [presentationType]="commissionSubmitToChartType"/>
      </div>
    </widget>
  </div>
  <div data-testid="yield-by-travel-type-widget-container" class="col-md-6 mt-24">
    <widget data-testid="yield-by-travel-type-widget" title="Yield By Travel Type">
      <ng-container data-testid="yield-by-travel-type-actions" widgetActions>
        <button data-testid="yield-by-travel-type-amount-button" mat-menu-item (click)="financeYieldTravelTypeChartType = FinanceChartPresentationTypeEnum.Amount">
          <mat-icon>attach_money</mat-icon>
          <span>Amount</span>
        </button>
        <button data-testid="yield-by-travel-type-percentage-button" mat-menu-item (click)="financeYieldTravelTypeChartType = FinanceChartPresentationTypeEnum.Percentage">
          <mat-icon>percent</mat-icon>
          <span>Percentage</span>
        </button>
      </ng-container>
      <div data-testid="yield-by-travel-type-chart-wrap" class="widget-chart-wrap" widgetContent>
        <app-yield-by-travel-type [data]="yieldByTravelTypeChartData" [presentationType]="financeYieldTravelTypeChartType"/>
      </div>
    </widget>
  </div>
  <div data-testid="yield-by-submit-to-widget-container" class="col-md-6 mt-24">
    <widget data-testid="yield-by-submit-to-widget" title="Yield By Submit To">
      <ng-container data-testid="yield-by-submit-to-actions" widgetActions>
        <button data-testid="yield-by-submit-to-amount-button" mat-menu-item (click)="financeYieldSubmitToChartType = FinanceChartPresentationTypeEnum.Amount">
          <mat-icon>attach_money</mat-icon>
          <span>Amount</span>
        </button>
        <button data-testid="yield-by-submit-to-percentage-button" mat-menu-item (click)="financeYieldSubmitToChartType = FinanceChartPresentationTypeEnum.Percentage">
          <mat-icon>percent</mat-icon>
          <span>Percentage</span>
        </button>
      </ng-container>
      <div data-testid="yield-by-submit-to-chart-wrap" class="widget-chart-wrap" widgetContent>
        <app-yield-by-submit-to [data]="yieldBySubmitToChartData" [presentationType]="financeYieldSubmitToChartType"/>
      </div>
    </widget>
  </div>
  <div class="row mt-24">
    <div data-testid="finance-dashboard-sales-activity-report-by-travel-type-widget-content" widgetContent>
      <div data-testid="finance-dashboard-sales-activity-report-by-travel-type-list-wrap">
        <app-sales-activity-travel-type-list/>
      </div>
    </div>
  </div>
  <div class="row mt-24">
    <div data-testid="finance-dashboard-sales-activity-report-by-submit-to-widget-content" widgetContent>
      <div data-testid="finance-dashboard-sales-activity-report-by-submit-to-list-wrap">
        <app-sales-activity-submit-to-list/>
      </div>
    </div>
  </div>
</div>
